<div class="row text-center confirm-email">
  <div class="col">
    <h1 class="title-copy">
      {{ "ACCOUNT_ACTIVATION" | translate }}
    </h1>
    <p>
      {{ "ACCOUNT_ACTIVATION_DESC" | translate }}
    </p>
    <form
      [formGroup]="confirmEmailForm"
      name="confirmEmailForm"
      (ngSubmit)="confirmEmailForm.valid && confirmEmail()"
      class="s-signUpForm"
    >
      <div class="input">
        <mapfre-validation
          [input]="inputs[0]"
          [form]="confirmEmailForm"
        ></mapfre-validation>
      </div>
      <div class="row group-button text-center">
        <div class="col">
          <mapfre-button
            [additionalClasses]="'basic primary large-btn'"
            [disabledValue]="confirmEmailForm.valid"
            [inputType]="'submit'"
            [translateValue]="'CONTINUE' | translate"
          ></mapfre-button>
        </div>
        <div class="col confirm-activate">
          <mapfre-button
          additionalClasses="link-button small red-link no-margin button-border-red account-activate-back"
          [backIcon]="'assets/img/images/confirm-email-arrow-left.png'"
          [iconClasses]="'align-middle'"
          [showIconsCustom]="true"
          [routerLink]="['/signup']"
        >{{ "BACK" | translate }}
        </mapfre-button>
        </div>
      </div>
    </form>
  </div>
</div>
